//Busca en título con metodo= 1 para que busque con el and
import { useNavigate } from "react-router-dom";
import normatecaStore from "../../stores/normatecaStore";
import Swal from "sweetalert2";
import {useEffect,  useRef } from "react";
//import $ from "https://code.jquery.com/jquery-3.6.2.min.js";

export default function Buscador(){
        // store - zuntand
    const navigate= useNavigate();
    const imgurl= process.env.REACT_APP_IMG_URL;
    const nas= process.env.REACT_APP_NAS;
    const sitio= process.env.REACT_APP_ENV;
    const inputRef= useRef();

    const { setContenido,setCambiaInputValueBusca,buscaInputValue,loading,setVisMenuP,opcMenu} =
        normatecaStore((state) =>( { 
           setContenido: state.setContenido,
           setCambiaInputValueBusca: state.setCambiaInputValueBusca,
           buscaInputValue: state.buscaInputValue,
           loading: state.loading,
           setVisMenuP:state.setVisMenuP,
           opcMenu: state.opcMenu,
    })); 
      useEffect(() => { 
        if(opcMenu==="busAva"){
            let scriptSC1 = document.getElementById("sc1");
            if (document.head.contains(scriptSC1)) {
                scriptSC1.remove();
            }
            let scriptSC2 = document.getElementById("sc2");
            if (document.head.contains(scriptSC2)) {
                scriptSC2.remove();
            }
            let script1 = document.createElement("script");
            script1.type = "text/javascript";
            script1.src = sitio==="LOCAL"? "/scripts/typeahead.min.js":"./scripts/typeahead.min.js";
            script1.id="sc1";
            let script2 = document.createElement("script");
            script2.type = "text/javascript";
            script2.src = sitio==="LOCAL"? "/scripts/the-basics.min.js" : "./scripts/the-basics.min.js";
            script2.id="sc2";
            document.head.appendChild(script1);
            document.head.appendChild(script2);
        }
    },[opcMenu==="busAva"]);     
     const cambiaContenido =(opcVis, indices,opcM)=>{
        //let c1= "$"; let c2="%"; let c3="/"; let c4="#"; let c5="*"; let c6="_"; let c7="-"; let c8="°"; let c9="¬"; let c10="|"; 
        loading(true);//función de store
        setVisMenuP("00").catch(null);
       
        switch(opcM){
            case "bus":
                 let buscarDiag= "/";
                 let buscaInputValueC = inputRef.current.value;
                 buscaInputValueC= buscaInputValueC.replace(new RegExp(buscarDiag,"g") ,"|")
                //buscaInputValue= buscaInputValue.replace(new RegExp(c1,"g") ,"").replace(new RegExp(c2,"g") ,"").replace(new RegExp(c3,"g") ,"").replace(new RegExp(c4,"g") ,"").replace(new RegExp(c5,"g") ,"")
               //                                 .replace(new RegExp(c6,"g") ,"").replace(new RegExp(c7,"g") ,"").replace(new RegExp(c8,"g") ,"").replace(new RegExp(c9,"g") ,"").replace(new RegExp(c10,"g") ,"");
                if (buscaInputValueC.trim()===""){
                    loading(false);//función de store
                    Swal.fire({//mensaje de 
                        title: "No hay elemento de búsqueda",
                        text: "",
                        icon: 'info',
                        showConfirmButton:false,
                        showCancelButton: true,
                        // confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#0077C8',
                        // confirmButtonText: 'Continuar',
                        cancelButtonText: 'Cerrar', 
                        //html: '<div>' + mensajeTem1 + '</div>' + '<div>' + mensajeTem2 + '</div>' + '<div>' + mensajeTem3 + '</div>'
                        }).then((result) => {
                        if (result.isConfirmed) {
                            return;
                        }
                    }) 
                }
                else{
                    inputRef.current.value="";
                    setCambiaInputValueBusca("");
                    navigate("/app/normateca/q=" + buscaInputValueC);
                    loading(false);//función de store
                 }
                break;
            case "busAvaOpc":
                loading(false);//función de store
                setContenido(opcVis,indices,opcM).catch(null);
                navigate("/app/normateca/busAvaOpc");
                break;

        }
     }
     const pressEnter=(e)=>{
       if (e.key === "Enter") {
           cambiaContenido("bus",0,"bus");
        }
     }
     const limpiaInput=()=>{
        inputRef.current.value="";
        setCambiaInputValueBusca("");
     }
     const cambiaValue=()=>{
        setCambiaInputValueBusca(inputRef.current.value);
     }
     
    return (
        <div className="buscador">
            <div className="display-inlineflex" >
            {opcMenu==="busAvaOpc"?
                    <input type="text" id="inB" name="inB"  placeholder="Buscar en el título..." className="buscartxt buscarDisable" maxLength={249}/>
                :
                <div className="input-group" id="the-basics">
                    <input ref={inputRef}   type="text" id="inputQ" name="inputQ"  placeholder="Buscar en el título..." className="buscartxt typeahead" data-lang="in_busqueda" onChange={cambiaValue} onKeyDown={e => pressEnter(e)} maxLength={249}/>
                </div> 
            }
                <div className={buscaInputValue!==""? "divline2":"divline"}></div>
                <div className={opcMenu==="busAvaOpc"? "":"divBtnbus"}>
                <div className={buscaInputValue!==""? "iconoBuscadorX display-block": "display-none"}><a id="aBusL" onClick={limpiaInput} className="aBusca" title={"limpiar"}><span className="inegi-cerrar"></span></a></div>
                <div className={opcMenu==="busAvaOpc"? "iconoBuscador visib-hidden":"iconoBuscador"}><a id="aBus" onClick={()=>cambiaContenido("bus",0,"bus")} className="aBusca" onKeyDown={e => pressEnter(e)} title={"buscar"}><span className="inegi-buscar"></span></a></div>
               </div>
            </div>
            <div>
                <div className="divBusAva display-inlineflex">
                    <div className="font-weight-bolder">Búsqueda avanzada     </div>
                    <div className="diviconoflecha">
                        <a onClick={()=>cambiaContenido("busAvaOpc",0,"busAvaOpc")} className="aBuscaAva" onKeyDown={()=>cambiaContenido("busAvaOpc",0,"busAvaOpc")}>
                            <span className="inegi-asc"></span>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div className="display-inlineflex">
                    <div>Descarga el Catálogo de Disposiciones Vigentes</div>
                    <div className="divcatalogo "><a href={nas + "cat_ntk.pdf"} target="_blank"><img src={imgurl + "ico/ico_pdf.png" }  /></a></div>
                </div>
            </div>
        </div>
    )
}